import React, { useCallback } from 'react';
import FormGroupTextArea from '../formGroupTextArea';
import Button from '../button';
import FormResponseMessage from '../formResponseMessage';
import CenteredDots from '../General/centeredDots';
import { Alert, RadioButtonGroup } from 'arag-ui-lib';
import { PREMIUM_SETTINGS_CHECKBOX_OPTIONS } from '../../helpers/variables';
import { ABANDONED_POLICY_STATUSES} from '../../helpers/constants'; 

const ChangeApplicationStatusModal = (props) => {
  const handleCheck = useCallback(
    (value) =>
      PREMIUM_SETTINGS_CHECKBOX_OPTIONS.map((c) => c.id).includes(value) ==
      false
        ? null
        : props.ChangeApplicationPolicySettings('premiumSettingsType', value),
    [props.Store.premiumSettingsType]
  );
  return (
    <div>
      <p>
        Are you sure you want to change the status to{' '}
        <b>{props.Store.selectedStatus}</b> ?
      </p>
      <div style={{ display: 'none' }}>
        <input
          id="sendEmailNotificationApplicationPolicy"
          type="checkbox"
          className="appFormRefSettings-check_box"
          checked={props.Store.sendEmailNotification}
          name="sendEmailNotification"
          onChange={(evt) => {
            props.ChangeApplicationPolicySettings(
              evt.target.name,
              !props.Store.sendEmailNotification
            );
          }}
        />
        <label htmlFor="sendEmailNotificationApplicationPolicy"></label>
        <span className="applicationsAndPolicies-checkbox-label applicationsAndPolicies-font">
          Send email notification
        </span>
      </div>
      {props.Store.multipleAppPremiumSettingsFound && (
          <RadioButtonGroup
            id="premiumType"
            onChange={handleCheck}
            value={props.Store.premiumSettingsType}
            options={PREMIUM_SETTINGS_CHECKBOX_OPTIONS}
          />
        )}
      {props.Store.selectedStatus.includes('Referred') && (
        <div className="form-horizontal">
          <FormGroupTextArea
            centerWrapper="col-sm-6 formGroupTextArea-wrapper"
            Label="Referred Reason"
            Name="referredReason"
            Value={props.newApplication.referredReason}
            HandleInputChange={props._changeNewAppField}
          />
        </div>
      )}
      {props.Store.selectedStatus.includes('Rejected') ? (
        <form className="form-horizontal">
          <FormGroupTextArea
            centerWrapper="col-sm-6 formGroupTextArea-wrapper"
            Label="Rejected Reason"
            Name="rejectedReason"
            Value={props.newApplication.rejectedReason}
            HandleInputChange={props._changeNewAppField}
          />
        </form>
      ) : null}
      {ABANDONED_POLICY_STATUSES.includes(props.Store.selectedStatus)? (
        <form className="form-horizontal">
          <FormGroupTextArea
            centerWrapper="col-sm-6 formGroupTextArea-wrapper"
            Label="Abandoned Reason"
            Name="abandonedReason"
            Value={props.newApplication.abandonedReason}
            HandleInputChange={props._changeNewAppField}
          />
        </form>
      ) : null}

      <div className="row">
        <div className="col-sm-12">
          <Button
            clickHandler={props._updatePolicyStatus}
            wrapper="btn-wrapper-forForms"
            btnType="button"
            btnStyle={'btn btn-primary btn-xs sharp yellow'}
            label="Confirm"
          />
          <Button
            clickHandler={() => {
              props.ChangeApplicationPolicySettings('selectedStatus', '');
              props.ChangeApplicationPolicySettings('premiumSettingsType', '');
            }}
            wrapper="btn-wrapper-forForms"
            btnType="button"
            btnStyle={'btn btn-primary btn-xs sharp white'}
            label="Cancel"
          />
        </div>
        {props.Store.patching ? <CenteredDots /> : null}
        {props.newApplication.badMsg ? (
          <div className="col-sm-12">
            <form className="form-horizontal">
              <FormResponseMessage
                LeftWrapper=""
                CenterWrapper="col-sm-12"
                MessageStyle="formResponseMessage-reject"
                Message={props.newApplication.badMsg}
              />
            </form>
          </div>
        ) : null}
        {props.badResponseAppPsMessage && (
          <FormResponseMessage
            LeftWrapper=""
            CenterWrapper="col-sm-12"
            MessageStyle="formResponseMessage-reject"
            Message={props.badResponseAppPsMessage}
          />
        )}
        {props.Store.multipleAppPremiumSettingsFound && (
            <div className="col-sm-12">
              <Alert
                variant="info"
                label={
                  'Multiple premium settings found. Please select the desired type and submit again'
                }
              />
            </div>
          )}
        {props.Store.failedToReceivePremiumMsg &&
          props.Store.multipleAppPremiumSettingsFound == false && (
            <div className="col-sm-12">
              <Alert
                variant="error"
                label={props.Store.failedToReceivePremiumMsg}
              />
            </div>
          )}
      </div>
    </div>
  );
};

export default ChangeApplicationStatusModal;
